type SavedSolarDesign = {
  id: string;
  revision: number;
};

type CreateEstimateFromDesign = (input: {
  projectId: string;
  categories: ['SOLAR'];
  solar: {
    sourceDesign: {
      publicId: string;
      revision: number;
    };
  };
}) => void;

/** Persist first, then create from the exact design revision acknowledged by the server. */
export const createEstimateFromSavedDesign = async (
  projectId: string,
  persistDesign: () => Promise<SavedSolarDesign>,
  createEstimate: CreateEstimateFromDesign
) => {
  const savedDesign = await persistDesign();
  createEstimate({
    projectId,
    categories: ['SOLAR'],
    solar: {
      sourceDesign: {
        publicId: savedDesign.id,
        revision: savedDesign.revision,
      },
    },
  });
};
